export var canEditComment = function canEditComment(isAssignmentEnded, disabled, isOnGradingProcess) {
  return !!isAssignmentEnded && !disabled && !isOnGradingProcess;
};
export var countWords = function countWords(text) {
  var cleanedText = text.replace(/<[^>]*>/g, ' ');
  var clearSpaceText = cleanedText.trim();

  if (!clearSpaceText) {
    return 0;
  }

  var words = clearSpaceText.split(/\s+/);
  return words.length;
};